import { render, staticRenderFns } from "./StoreLocatorConfigSection.vue?vue&type=template&id=32978dd5&scoped=true&"
import script from "./StoreLocatorConfigSection.vue?vue&type=script&lang=js&"
export * from "./StoreLocatorConfigSection.vue?vue&type=script&lang=js&"
import style0 from "./StoreLocatorConfigSection.vue?vue&type=style&index=0&id=32978dd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32978dd5",
  null
  
)

export default component.exports